import api from './api';

const productionService = {
  getEWOs:          (token)       => api.get('/production/ewos', token),
  createEWO:        (data, token) => api.post('/production/ewos', data, token),
  authorizeEWO:     (id, token)   => api.put(`/production/ewos/${id}/authorize`, {}, token),
  getMaterialOrders:(token)       => api.get('/production/material-orders', token),
  getPettyCash:     (token)       => api.get('/production/petty-cash', token),
  createPettyCash:  (data, token) => api.post('/production/petty-cash', data, token),
};

export default productionService;
